export function useDevice() {
  const deviceType = useState('deviceType', () => 'desktop');

  const updateDevice = () => {
    if (process.server) return;
    const width = window.innerWidth;
    let type = 'desktop';
    if (width < 768) {
      type = 'mobile';
    }

    deviceType.value = type;
  };

  return { deviceType, updateDevice };
}